import { nodeViewDecorators } from './../../../../ricos-common-plugins/viewer.js';
import type { NodeViewDecorator } from './../../../../ricos-types/index.js';

import { BreakoutDecorator } from './breakoutDecorator.js';
import { Decorators as NodeViewDecorators } from './nodeViewDecorators.js';

export const decorators: NodeViewDecorator<JSX.Element>[] = [
  ...nodeViewDecorators,
  BreakoutDecorator,
];

export default NodeViewDecorators;
